import BeefreeSDK from '@beefree.io/sdk';

export default class AlBeefreeEditorController {
    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;
        this.api = this.injector.get('$http');
        this.translate = this.injector.get('$translate');

        this.festzeltOsBeefreeCredentials = null;
        this.pluginInstance = null;
        this.beefreeSaveTrigger = null;
        this.contentDialogs = null;

        this._startLoading();
        this._resetContainerError();
    }

    $onInit() {
        this.saveCallback = () => {
            return this._triggerBeefreeSave();
        };

        this._loadBeefreeCredentials()
            .then(
                () => {
                    this._initInstance();
                },
                () => {
                    this._setContainerError(this._getTranslatedValue('credentials_load_error'));
                }
            );
    }

    _initInstance() {
        const authConf = {
            beePluginUrl: 'https://app-rsrc.getbee.io/plugin/BeePlugin.js'
        };

        this.pluginInstance = new BeefreeSDK({
            access_token: this.festzeltOsBeefreeCredentials.token,
            v2: true
        }, authConf);

        this._stopLoading();
        this.pluginInstance.start(
            {
                container: 'bee-plugin-container',
                preventClose: false,
                language: this._getTranslatedValue('beefree_locale'),
                onSave: (jsonFile, htmlFile) => {
                    this._triggerChange(jsonFile, htmlFile);

                    if (this.beefreeSaveTrigger) {
                        this.beefreeSaveTrigger({
                            json: jsonFile,
                            html: htmlFile
                        });
                    }
                },
                onAutoSave: (jsonFile, htmlFile) => {
                    this._triggerChange(jsonFile, htmlFile);
                },
                onError: (errorMessage) => {
                    this._handleBeeError(errorMessage);
                },
                contentDialog: this._getContentDialogs()
            },
            this._getTemplateToUseForEditor()
        ).then(
            () => {
                this._triggerEditorReady();
                this._stopLoading();
            },
            () => {
                this._setContainerError(this._getTranslatedValue('initializing_editor_error'))
            }
        );
    }

    _getTemplateToUseForEditor() {
        return this.startTemplate || this.festzeltOsBeefreeCredentials.default_template;
    }

    _loadBeefreeCredentials() {
        return this.api.get('services/credentials/beefree').then((response) => {
            this.festzeltOsBeefreeCredentials = _.get(response, 'data.data', null);
        });
    }

    _startLoading() {
        this.loading = true;
    }

    _stopLoading() {
        this.loading = false;
        this.scope.$applyAsync();
    }

    _setContainerError(message) {
        this.containerError = {
            active: true,
            message: message
        }
    }

    _resetContainerError() {
        this.containerError = {
            active: false,
            message: ''
        }
    }

    _getTranslatedValue(path, params) {
        return this.translate.instant(`templates.components.al-beefree-editor.${path}`, params || {});
    }

    _triggerChange(newJson, newHtml) {
        this.onSave({
            json: newJson,
            html: newHtml
        });
    }

    _triggerBeefreeSave() {
        return new Promise((resolve, reject) => {
            if (this.pluginInstance) {
                this.pluginInstance.save();

                this.beefreeSaveTrigger = resolve;
            } else {
                resolve();
            }
        });

    }

    _triggerEditorReady() {
        this.onEditorReady();
    }

    _getContentDialogs() {
        const out = {};

        _.each([
            'specialLinks',
            'mergeTags',
            'mergeContents',
            'rowDisplayConditions',
            'externalContentURLs',
            'saveRow'
        ], (dialogName) => {
            const givenDialog = _.get(this.contentDialogs, dialogName, null);
            if (!givenDialog || !_.isObject(givenDialog)) {
                return;
            }

            out[dialogName] = {
                label: givenDialog.label,
                handler: givenDialog.handler
            }
        });

        return out;
    }

    _handleBeeError(errorMessage) {
        if (errorMessage && errorMessage.code === 5101) {
            // Token expired but can be refreshed within 12-hour window
            this._refreshToken();
        } else if (errorMessage && errorMessage.code === 5102) {
            // Session expired after 12 hours, needs full re-initialization
            this._reinitializeEditor();
        } else {
            console.error('BEE Plugin error:', errorMessage);
        }
    }

    _refreshToken() {
        this._loadBeefreeCredentials().then(() => {
            if (this.pluginInstance && this.pluginInstance.instance) {
                this.pluginInstance.instance.updateToken(this.festzeltOsBeefreeCredentials.token);
            }
        });
    }

    _reinitializeEditor() {
        this.pluginInstance = null;
        this._startLoading();
        this._loadBeefreeCredentials().then(
            () => {
                this._initInstance();
            },
            () => {
                this._setContainerError(this._getTranslatedValue('credentials_load_error'));
            }
        );
    }
}

AlBeefreeEditorController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/templates/components/al-beefree-editor/controller.js